// Interactions shared between builders
export const FETCH_ACCOUNTS = 'builder.fetchUserAccounts';
export const FETCH_FLOWS_SUMMARY = 'builder.fetchFlowsSummary';
export const FETCH_USER_PROPERTIES = 'builder.fetchUserProperties';
export const FETCH_BOOTSTRAP = 'builder.fetchBootstrap';
